import { render } from "./DsoEmailVerification.vue?vue&type=template&id=b966237c&scoped=true"
import script from "./DsoEmailVerification.vue?vue&type=script&lang=js"
export * from "./DsoEmailVerification.vue?vue&type=script&lang=js"

import "./DsoEmailVerification.vue?vue&type=style&index=0&id=b966237c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b966237c"]])

export default __exports__